// extracted by mini-css-extract-plugin
module.exports = {"handle":"ChatsListResizeHandle_handle__rh4SA","grip":"ChatsListResizeHandle_grip__3rCZf"};